<template>
  <component
    :is="resolvedIcon"
    :size="size"
    :stroke-width="1.75"
    aria-hidden="true"
  />
</template>

<script>
import Archive from 'lucide-vue/dist/esm/icons/archive.js'
import ArrowLeft from 'lucide-vue/dist/esm/icons/arrow-left.js'
import ArrowRight from 'lucide-vue/dist/esm/icons/arrow-right.js'
import Banknote from 'lucide-vue/dist/esm/icons/banknote.js'
import BookCheck from 'lucide-vue/dist/esm/icons/book-check.js'
import Bot from 'lucide-vue/dist/esm/icons/bot.js'
import BriefcaseBusiness from 'lucide-vue/dist/esm/icons/briefcase-business.js'
import Calculator from 'lucide-vue/dist/esm/icons/calculator.js'
import CalendarCheck from 'lucide-vue/dist/esm/icons/calendar-check.js'
import CalendarDays from 'lucide-vue/dist/esm/icons/calendar-days.js'
import ChartNoAxesCombined from 'lucide-vue/dist/esm/icons/chart-no-axes-combined.js'
import ChevronDown from 'lucide-vue/dist/esm/icons/chevron-down.js'
import ChevronUp from 'lucide-vue/dist/esm/icons/chevron-up.js'
import CircleHelp from 'lucide-vue/dist/esm/icons/circle-help.js'
import ClipboardX from 'lucide-vue/dist/esm/icons/clipboard-x.js'
import Contact from 'lucide-vue/dist/esm/icons/contact.js'
import ContactRound from 'lucide-vue/dist/esm/icons/contact-round.js'
import CreditCard from 'lucide-vue/dist/esm/icons/credit-card.js'
import FileCheck2 from 'lucide-vue/dist/esm/icons/file-check-2.js'
import FileText from 'lucide-vue/dist/esm/icons/file-text.js'
import FileUp from 'lucide-vue/dist/esm/icons/file-up.js'
import Funnel from 'lucide-vue/dist/esm/icons/funnel.js'
import Gauge from 'lucide-vue/dist/esm/icons/gauge.js'
import Headphones from 'lucide-vue/dist/esm/icons/headphones.js'
import History from 'lucide-vue/dist/esm/icons/history.js'
import Eye from 'lucide-vue/dist/esm/icons/eye.js'
import Kanban from 'lucide-vue/dist/esm/icons/kanban.js'
import Landmark from 'lucide-vue/dist/esm/icons/landmark.js'
import ListChecks from 'lucide-vue/dist/esm/icons/list-checks.js'
import ListTodo from 'lucide-vue/dist/esm/icons/list-todo.js'
import LogOut from 'lucide-vue/dist/esm/icons/log-out.js'
import Mail from 'lucide-vue/dist/esm/icons/mail.js'
import Megaphone from 'lucide-vue/dist/esm/icons/megaphone.js'
import MessageCircle from 'lucide-vue/dist/esm/icons/message-circle.js'
import MessagesSquare from 'lucide-vue/dist/esm/icons/messages-square.js'
import Package from 'lucide-vue/dist/esm/icons/package.js'
import PackageCheck from 'lucide-vue/dist/esm/icons/package-check.js'
import PanelLeftClose from 'lucide-vue/dist/esm/icons/panel-left-close.js'
import PanelLeftOpen from 'lucide-vue/dist/esm/icons/panel-left-open.js'
import Pencil from 'lucide-vue/dist/esm/icons/pencil.js'
import Plus from 'lucide-vue/dist/esm/icons/plus.js'
import ReceiptText from 'lucide-vue/dist/esm/icons/receipt-text.js'
import Settings from 'lucide-vue/dist/esm/icons/settings.js'
import ShoppingBasket from 'lucide-vue/dist/esm/icons/shopping-basket.js'
import ShoppingCart from 'lucide-vue/dist/esm/icons/shopping-cart.js'
import Tags from 'lucide-vue/dist/esm/icons/tags.js'
import TrendingUp from 'lucide-vue/dist/esm/icons/trending-up.js'
import Trash2 from 'lucide-vue/dist/esm/icons/trash-2.js'
import Truck from 'lucide-vue/dist/esm/icons/truck.js'
import Users from 'lucide-vue/dist/esm/icons/users.js'
import WalletCards from 'lucide-vue/dist/esm/icons/wallet-cards.js'
import Warehouse from 'lucide-vue/dist/esm/icons/warehouse.js'
import X from 'lucide-vue/dist/esm/icons/x.js'

const ICONS = {
  'bi-archive': Archive,
  'bi-arrow-left': ArrowLeft,
  'bi-arrow-right': ArrowRight,
  'bi-bag-check': PackageCheck,
  'bi-bank': Landmark,
  'bi-basket': ShoppingBasket,
  'bi-box2': Package,
  'bi-calculator': Calculator,
  'bi-calendar-check': CalendarCheck,
  'bi-calendar-event': CalendarDays,
  'bi-cart4': ShoppingCart,
  'bi-cash-stack': Banknote,
  'bi-chevron-down': ChevronDown,
  'bi-chevron-up': ChevronUp,
  'bi-clipboard-x': ClipboardX,
  'bi-clock-history': History,
  'bi-credit-card': CreditCard,
  'bi-eye': Eye,
  'bi-eye-fill': Eye,
  'bi-file-earmark-arrow-up': FileUp,
  'bi-file-earmark-check': FileCheck2,
  'bi-file-earmark-text': FileText,
  'bi-file-ruled': FileText,
  'bi-funnel': Funnel,
  'bi-gear': Settings,
  'bi-graph-up': ChartNoAxesCombined,
  'bi-graph-up-arrow': TrendingUp,
  'bi-headset': Headphones,
  'bi-house': Warehouse,
  'bi-journal-check': BookCheck,
  'bi-kanban': Kanban,
  'bi-layout-sidebar-inset': PanelLeftClose,
  'bi-list-check': ListChecks,
  'bi-list-task': ListTodo,
  'bi-megaphone': Megaphone,
  'bi-envelope': Mail,
  'bi-chat-dots': MessagesSquare,
  'bi-people': Users,
  'bi-person-badge': Contact,
  'bi-person-lines-fill': ContactRound,
  'bi-person-rolodex': ContactRound,
  'bi-person-workspace': BriefcaseBusiness,
  'bi-pencil': Pencil,
  'bi-pencil-square': Pencil,
  'bi-plus': Plus,
  'bi-plus-lg': Plus,
  'bi-receipt': ReceiptText,
  'bi-robot': Bot,
  'bi-speedometer': Gauge,
  'bi-tags': Tags,
  'bi-trash': Trash2,
  'bi-trash-fill': Trash2,
  'bi-truck': Truck,
  'bi-wallet': WalletCards,
  'bi-wallet2': WalletCards,
  'bi-whatsapp': MessageCircle,
  'bi-box-arrow-left': LogOut,
  'bi-x-lg': X,
  'panel-left-close': PanelLeftClose,
  'panel-left-open': PanelLeftOpen,
  'circle-help': CircleHelp
}

export default {
  name: 'SidebarIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 20
    }
  },
  computed: {
    resolvedIcon() {
      const iconName = this.name.split(/\s+/).find(name => ICONS[name])
      return ICONS[iconName] || CircleHelp
    }
  }
}
</script>
